import { buildSortedSQL } from "./buildSortedSQL";
import { TABLE_PAGE_SIZE } from "./tablePaginationUtils";

/**
 * Build sql_query and pagination params for POST /api/query/execute-sql.
 *
 * Unsorted load-more: pass base SQL; offset/limit go in the request body.
 * Sorted load-more: pass wrapped sorted_sql; offset/limit go in the request body
 * (backend strips any LIMIT/OFFSET from the SQL and applies request params).
 *
 * @param {string} baseSql - Original query SQL (final_generated_sql_query)
 * @param {{ sortedSql?: string, columnName?: string, sortOrder?: string, limit?: number|null }|null} activeSort
 * @param {{ offset?: number, limit?: number }} pagination
 * @returns {{ sql: string, offset: number, limit: number }|null}
 */
export function resolveExecuteSqlQuery(baseSql, activeSort, pagination = {}) {
  if (!baseSql) return null;

  const requestOffset = Number(pagination.offset) || 0;
  const requestLimit = Number(pagination.limit) || TABLE_PAGE_SIZE;

  const hasSort =
    activeSort &&
    (activeSort.sortedSql || (activeSort.columnName && activeSort.sortOrder));

  if (!hasSort) {
    return { sql: baseSql, offset: requestOffset, limit: requestLimit };
  }

  let sortedSql = activeSort.sortedSql;
  if (!sortedSql) {
    sortedSql = buildSortedSQL(
      baseSql,
      activeSort.columnName,
      activeSort.sortOrder,
      activeSort.limit ?? null
    );
  }

  return { sql: sortedSql, offset: requestOffset, limit: requestLimit };
}
